// Tutorials: start a guided tour, remember finished ones, offer a screen's tour on its first visit, launch the practice ride.
import { startTour, onTourEnd, tourRunning, checkTour } from './tour.js';
import { TOURS, tourById, TOUR_FOR_NAV } from './tours.js';
import { state, update } from '../../data/store.js';
import { esc, toast } from '../dom.js';
import { t } from '../../i18n/index.js';
import { errorText } from '../../i18n/content.js';
import { raceConfig } from '../../data/creations.js';
import { startRide, isRiding } from '../ride/start.js';

export { TOURS };

// access point for the e2e journey: replays every tour and lists the steps whose element has disappeared
window.__gvTours = { ids: () => TOURS.map(d => d.id), check: (id: string) => checkTour(tourById(id)!) };

onTourEnd((id, done) => { if (done) update(s => { if (!s.tours.done.includes(id)) s.tours.done.push(id); }); });

export function runTour(id: string) {
  const def = tourById(id);
  if (!def) return;
  closeOffer();
  update(s => { if (!s.tours.offered.includes(id)) s.tours.offered.push(id); });
  startTour(def);
}

/** Practice ride: a short, flat race against three easy bots, with the coach. */
export async function startPractice() {
  closeOffer();
  try { await startRide({ race: raceConfig({ mode: 'race', track: 'mur', laps: 1, bots: 3, diff: 'facile', items: [] }), coach: true }); }
  catch (e) { console.error(e); toast(errorText(e.message), 'bad'); }
}

let offerEl: HTMLElement | null = null;
const closeOffer = () => { offerEl?.remove(); offerEl = null; };

/** First visit of a screen that has a tour: a small, non-blocking card offers it (once per tour). */
export function offerTourFor(nav: string) {
  closeOffer();
  const id = TOUR_FOR_NAV[nav];
  if (!id || !state.onboarded || tourRunning() || isRiding() || document.querySelector('.overlay')) return;
  if (state.tours.done.includes(id) || state.tours.offered.includes(id)) return;
  update(s => { s.tours.offered.push(id); });
  const T = t.tour, name = T.tours[id as keyof typeof T.tours].title;
  offerEl = document.createElement('div');
  offerEl.className = 'tour-offer';
  offerEl.setAttribute('role', 'status');
  offerEl.innerHTML = `<b>${esc(T.offer.title(name))}</b><p>${esc(T.offer.body)}</p><div class="inline"><button class="primary" data-offer="go">${esc(T.offer.start)}</button><button class="ghost" data-offer="later">${esc(T.offer.later)}</button></div>`;
  offerEl.addEventListener('click', e => {
    const b = (e.target as HTMLElement).closest('[data-offer]') as HTMLElement | null;
    if (!b) return;
    if (b.dataset.offer === 'go') runTour(id); else closeOffer();
  });
  document.body.appendChild(offerEl);
}

let routeSeq = 0;
/** Wires the offers to navigation; called once at start-up. */
export function startTutorials() {
  document.addEventListener('route', (e: Event) => {
    const nav = (e as CustomEvent<{ nav: string }>).detail.nav;
    closeOffer();
    // after the screen has drawn, so the offer never covers a loading state
    const seq = ++routeSeq;
    setTimeout(() => { if (seq === routeSeq) offerTourFor(nav); }, 1200);
  });
}
